import { BACKEND } from "@/lib/api";

export const photoSrc = (id) => `${BACKEND}/api/designer/photos/${id}/preview`;
export const newCell = (photo_id = null) => ({ photo_id, rot: 0, zoom: 1, fx: 0.5, fy: 0.5 });

const rotatedDims = (p, rot) => (rot % 180 ? [p.height, p.width] : [p.width, p.height]);

// Mirrors backend crop_box: cover * zoom, offset = (scaled - box) * focus, on the rotated image
export const cellGeometry = (photo, cell, cw, ch) => {
  const [rw, rh] = rotatedDims(photo, cell.rot);
  const s = Math.max(cw / rw, ch / rh) * cell.zoom;
  const dw = rw * s, dh = rh * s;
  const overX = dw - cw, overY = dh - ch;
  const iw = cell.rot % 180 ? dh : dw, ih = cell.rot % 180 ? dw : dh;
  return {
    overX, overY,
    wrap: { left: -overX * cell.fx, top: -overY * cell.fy, width: dw, height: dh },
    img: { width: iw, height: ih, left: (dw - iw) / 2, top: (dh - ih) / 2, transform: `rotate(${cell.rot}deg)` },
  };
};

export const cellPpi = (photo, cell, rect, wcm, hcm) => {
  const [rw, rh] = rotatedDims(photo, cell.rot);
  const sCm = Math.max((rect[2] * wcm) / rw, (rect[3] * hcm) / rh) * cell.zoom;
  return Math.round(2.54 / sCm);
};

export const ppiLevel = (ppi, cfg) => (ppi >= cfg.ppi_good ? "good" : ppi >= cfg.ppi_min ? "ok" : "low");

export const LAYOUT_LABEL = { 1: "Foto individual", 2: "2 fotos", 3: "3 fotos", 4: "4 fotos", 6: "6 fotos", 9: "9 fotos" };
